export const ESIGN_AUTOMATION_CODES = {
  irpf: "1",
  receita: "2",
  fichaAtendimento: "3",
  guiaConsulta: "4",
  guiaSP: "5",
  consentimentoPaciente: "6",
  termoLgpd: "7",
} as const;

export const TASY_AUTOMATION_CODES: readonly string[] = [
  ESIGN_AUTOMATION_CODES.fichaAtendimento,
  ESIGN_AUTOMATION_CODES.guiaConsulta,
  ESIGN_AUTOMATION_CODES.guiaSP,
  ESIGN_AUTOMATION_CODES.consentimentoPaciente,
  ESIGN_AUTOMATION_CODES.termoLgpd,
];

export const WORD_FILE_AUTOMATION_CODES: readonly string[] = [
  ESIGN_AUTOMATION_CODES.fichaAtendimento,
  ESIGN_AUTOMATION_CODES.guiaConsulta,
  ESIGN_AUTOMATION_CODES.guiaSP,
  ESIGN_AUTOMATION_CODES.termoLgpd,
];

export const HEADER_FOOTER_AUTOMATION_CODES: readonly string[] = [
  ESIGN_AUTOMATION_CODES.irpf,
  ESIGN_AUTOMATION_CODES.receita,
  ESIGN_AUTOMATION_CODES.consentimentoPaciente,
];
